import React from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";

// Context
import AppProvider from "./contexts/appContext";

// Components
import Protected from "./components/Protected";


// Pages
import About from "./pages/About";
import Game from "./pages/Game";
import GameBoard from "./pages/GameBoard";
import GameEnd from "./pages/GameEnd";
import GameMenu from "./pages/GameMenu";
import GamePlay from "./pages/GamePlay";
import Home from "./pages/Home";
import Landing from "./pages/Landing";
import NotFound from "./pages/NotFound";
import Profile from "./pages/Profile";
import ProfileDetails from "./pages/ProfileDetails";
import ProfileStats from "./pages/ProfileStats";
import SignIn from "./pages/SignIn";
import SignUp from "./pages/SignUp";


function App() {
  return (
    <AppProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/signup" element={<SignUp />} />
          <Route path="/signin" element={<SignIn />} />
          <Route
            path="/games"
            element={
              <Protected>
                <Home />
              </Protected>
            }
          />

          <Route
            path="/g/:game_id"
            element={
              <Protected>
                <Game />
              </Protected>
            }
          >
            <Route index element={<GameMenu />} />
            <Route path="play" element={<GamePlay />} />
            <Route path="end" element={<GameEnd />} />
            <Route path="leaderboard" element={<GameBoard />} />
          </Route>

          <Route
            path="/p/:playerId"
            element={
              <Protected>
                <Profile />
              </Protected>
            }
          >
            <Route index element={<ProfileDetails />} />
            <Route path="stats" element={<ProfileStats />} />
            <Route path="edit" element={<ProfileDetails />} />
          </Route>

          <Route path="/about" element={<About />} />
          <Route path="/404" element={<NotFound />} />
          <Route path="*" element={<Navigate to="/404" replace />} />
        </Routes>
      </BrowserRouter>
      <ToastContainer
        className="max-w-sm w-auto"
        toastClassName={() =>
          "bg-retro-grey relative p-3 min-h-10 mb-3 last:mb-0 rounded-md flex justify-between overflow-hidden cursor-pointer font-retro-rounded text-base"
        }
        bodyClassName={() => "flex items-center gap-1 text-black text-base whitespace-pre-line"}
        position="bottom-right"
        closeButton={false}
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </AppProvider>
  );
}

export default App;
